import {historyUpdate} from '@raison/navigation';
import {createReducer, isAnyOf} from '@reduxjs/toolkit';
import {Modal, Modals} from './modalsApi';

export type ModalsState = {
    /**
     * @private use modalsApi.select() to access modal state
     */
    __current: Modal | null;
};

const initialState: ModalsState = {
    __current: null,
};

export const modalsReducer = createReducer(initialState, builder => {
    builder.addCase(Modals.open, (state, action) => {
        state.__current = action.payload;
    });
    builder.addCase(Modals.close, (state, action) => {
        if (state.__current?.id === action.payload.id) {
            state.__current = null;
        }
    });
    builder.addCase(Modals.toggle, (state, action) => {
        if (state.__current?.id === action.payload.id) {
            state.__current = null;
        } else {
            state.__current = action.payload;
        }
    });
    builder.addMatcher(isAnyOf(Modals.clear, historyUpdate.isPop), state => {
        state.__current = null;
    });
});
